import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'

interface AdminRouteProps {
  children: React.ReactNode
  // Individual admin tools can require a narrower capability than the hub
  // itself — e.g. Categories CRUD is 'manage_categories', not every
  // 'moderate' holder (see LESSONS_LEARNED.md, Admin Hub + Categories).
  // Redirects to /admin (not /) so a moderator without this capability
  // still lands somewhere they're allowed to be.
  capability?: string
}

export function AdminRoute({ children, capability = 'moderate' }: AdminRouteProps) {
  const { isAuthenticated, isRestoring, hasCapability } = useAuthStore()

  if (isRestoring) return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!hasCapability('moderate')) return <Navigate to="/" replace />
  if (!hasCapability(capability)) return <Navigate to="/admin" replace />

  return <>{children}</>
}
